var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292893 12.2929C-0.0976311 12.6834 -0.0976311 13.3166 0.292893 13.7071L6.65685 20.0711C7.04738 20.4616 7.68054 20.4616 8.07107 20.0711C8.46159 19.6805 8.46159 19.0474 8.07107 18.6569L2.41421 13L8.07107 7.34315C8.46159 6.95262 8.46159 6.31946 8.07107 5.92893C7.68054 5.53841 7.04738 5.53841 6.65685 5.92893L0.292893 12.2929ZM28 12L1 12L1 14L28 14V12Z"}));
}

ArrowLeft.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"#28282D"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
